import React, { useRef } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import CloseIcon from "@mui/icons-material/Close";

/**
 * プロジェクトヘルプウィジェットのヘッダー部分
 */
export default function ProjectHelpHeader({
  open,
  dragging,
  onToggle,
  onPointerDown,
  onPointerMove,
  onPointerUp,
  onPointerCancel,
  isDesktop = false,
}) {
  // pointerdown 時の位置を保持（クリック判定用）
  const downPosRef = useRef({ x: 0, y: 0 });
  const movedRef = useRef(false);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 2,
        py: 1.25,
        cursor: dragging ? "grabbing" : "grab",
        borderBottom: "1px solid #e5e7eb",
        gap: 1,

        // ドラッグ中だけ none / 通常時は manipulation にする
        touchAction: dragging ? "none" : "manipulation",
        userSelect: "none",
      }}
      onPointerDown={(e) => {
        // 左クリック/タッチだけ
        if (e.button != null && e.button !== 0) return;

        downPosRef.current = { x: e.clientX, y: e.clientY };
        movedRef.current = false;

        // pointer capture は親のドラッグ処理側でやる想定
        onPointerDown?.(e);
      }}
      onPointerMove={(e) => {
        const dx = Math.abs(e.clientX - downPosRef.current.x);
        const dy = Math.abs(e.clientY - downPosRef.current.y);
        if (dx > 6 || dy > 6) movedRef.current = true;

        onPointerMove?.(e);
      }}
      onPointerUp={(e) => {
        // 先に親で dragging を解除
        onPointerUp?.(e);

        // クリック（ほぼ移動なし）なら開閉
        if (!movedRef.current) onToggle?.();
      }}
      onPointerCancel={(e) => {
        // cancel は「ドラッグ終了」と同等に扱う
        onPointerCancel?.(e);
      }}
    >
      <AssignmentTurnedInIcon sx={{ fontSize: 20 }} />

      <Typography
        fontWeight="bold"
        sx={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          flex: "unset",
          textAlign: "center",
        }}
      >
        企業側によく聞かれるポイント
      </Typography>

      <IconButton
        sx={{ p: 0 }}
        size="small"
        onPointerDown={(e) => e.stopPropagation()}
        onPointerUp={(e) => e.stopPropagation()}
        onClick={(e) => {
          e.stopPropagation();
          onToggle?.();
        }}
      >
        {isDesktop ? (
          // Desktop
          <ExpandMoreIcon
            sx={{
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
              transition: "0.2s",
            }}
          />
        ) : (
          // Mobile
          <CloseIcon sx={{ fontSize: 18 }} />
        )}
      </IconButton>
    </Box>
  );
}
